module.exports = __webpack_public_path__ + "img/caret-square-up.f6745cdc.svg";